import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../../App'
import Spinner from '../../../components.js/elements/Spinner'
import HeaderReturn from '../../../components.js/serveur/siteWeb/HeaderReturn'
import imageSiteWeb from '../../../images/imagesiteweb.png'
import useFirebase from './../../../firebase/useFirebase';

const SiteWeb = () => {
    const { user } = useContext(AppContext)
    const [montage, setMontage] = useState(true)
    const { readData, profil } = useFirebase()

    useEffect(() => {
        readData(user.uid)
        window.scrollTo(0, 0)
        setMontage(false)
        console.log('site web ',)
    },[])

    if (montage) return <Spinner />
    
    return (
        <div className='container-fluid'>
            <HeaderReturn title='Site web' image={imageSiteWeb} link='/homeServeur'/>

            <div>

                {profil.map(p => (
                    <div key={p.id}>
                        {p.icon &&
                            <div className='mt-4'>
                                <div className='text-center h2'>Icon</div>
                                <div className='text-center'>
                                    <img className='w-50' src={p.icon} alt='qr code android' />
                                </div>
                            </div>
                        }
                        {p.qrcodeAndroid && 
                            <div className='mt-4'>
                                <div className='text-center h2'>Android</div>
                                <div className='text-center'>
                                <img className='w-75' src={p.qrcodeAndroid} alt='qr code android' />
                                </div>
                            </div>
                        }
                        {p.qrcodeApple &&
                            <div className='mt-4'>
                                <div className='text-center h2'>Apple</div>
                                <div className='text-center'>
                                <img className='w-75' src={p.qrcodeApple} alt='qr code android' />
                                </div>
                            </div>
                        }
                    </div>
                ))}

            </div>

        </div>
    )
}

export default SiteWeb
